import { render, staticRenderFns } from "./ParametersHome.vue?vue&type=template&id=2ad8a7ae&"
import script from "./ParametersHome.vue?vue&type=script&lang=js&"
export * from "./ParametersHome.vue?vue&type=script&lang=js&"
import style0 from "./ParametersHome.vue?vue&type=style&index=0&id=2ad8a7ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports